import React from 'react'
import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { WEBAPPVERSION } from '../utils/version'
import { URL } from '../utils/tsUtils/Env'

const Wrapper = styled.div`
  padding: 12px 32px;
  background: ${(props) => props.theme.palette.background.paper};
  border-top: 1px solid ${(props) => props.theme.palette.divider};
  position: fixed;
  bottom: 0;
  left: 258px;
  right: 0;
  z-index: 1000;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  
  ${(props) => props.theme.breakpoints.down('md')} {
    left: 0;
  }
`

const FooterContent = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  max-width: 100%;
`

const LeftSection = styled(Box)`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
`

const RightSection = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`

const FooterText = styled(Typography)`
  font-size: 13px;
  color: ${(props) => props.theme.palette.text.secondary};
  font-weight: 400;
`

const VersionBadge = styled.span`
  background: ${(props) => props.theme.palette.mode === 'dark' 
    ? 'rgba(255, 255, 255, 0.1)' 
    : 'rgba(0, 0, 0, 0.06)'};
  color: ${(props) => props.theme.palette.text.primary};
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  border: 1px solid ${(props) => props.theme.palette.divider};
`

const CompanyLink = styled.a`
  color: ${(props) => props.theme.palette.primary.main};
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
  transition: color 0.2s;
  
  &:hover {
    color: ${(props) => props.theme.palette.primary.dark};
    text-decoration: underline;
  }
`

const Divider = styled.span`
  color: ${(props) => props.theme.palette.divider};
  margin: 0 4px;
`

function Footer() {
  return (
    <Wrapper>
      <FooterContent>
        <LeftSection>
          <FooterText>
            © {new Date().getFullYear()} XPOS Dashboard. All rights reserved.
          </FooterText>
          <VersionBadge>Version {WEBAPPVERSION}</VersionBadge>
        </LeftSection>
        <RightSection>
          <FooterText>
            Powered by
          </FooterText>
          <CompanyLink
            href={URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            NGX Technologies
          </CompanyLink>
        </RightSection>
      </FooterContent>
    </Wrapper>
  )
}

export default Footer
